import { State } from '../../../store/state';

export const templatesSelector = (state: State) => state.template.templates;
export const templateSelector = (state: State) => state.template.template;
export const optionsSelector = (state: State) => state.template.options;
export const errorCodeSelector = (state: State) => state.template.errorCode;
